import React from 'react';
import { Toastr } from 'modules/toastr';
import { Reception } from 'api';
import { msg } from "constants/message";
import { Link } from 'react-router';
import { checkServerLive, LimitFileSize, LimitFileType } from 'constants/config';
import { ShowIf } from 'components/utils';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';

class UploadNonTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      arrayFile: this.props.arrayFileUpload,
      type: this.props.typeArrayUpload
    }
  }

  uploadFile(index, e){
    if (e.target.files[0]) {

      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      if (LimitFileType.indexOf(ext) == -1) {
        Toastr(msg.fileTypeErr, 'warning');
      } else if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {

        let params = {
          field: 'file',
          file: e.target.files[0]
        };

        if (index == this.state.arrayFile.length) {
          this.addArrayFile(this.state.type);
        }

        params.progress = (progress) => {

          let progressBar = Math.round((progress.loaded * 100) / progress.total);

          this.state.arrayFile[index].progress = progressBar;

          this.setState({
            arrayFile: this.state.arrayFile
          })
        }

        Reception.actions.postFileUpload.request('', params).then(res => {

          this.state.arrayFile[index].progress = 0;
          this.state.arrayFile[index].tenFile = fileName;
          this.state.arrayFile[index].urlFile = res.data ? res.data.id : '';

          this.setState({
            arrayFile: this.state.arrayFile
          }, () => {
            this.props.onChange(this.state.arrayFile);
          });
        });
      }
    }
  }

  addArrayFile (typeArrayUpload) {

    let arrLength = this.state.arrayFile.length;
    this.state.arrayFile[arrLength] = {

      loaiFileDinhKem: typeArrayUpload,
      tenFile: '',
      urlFile: '',
      progress: 1,
      id: 0
    };
    this.setState({
      arrayFile: this.state.arrayFile
    });
  }

  handleRemove(index) {
    let newData = [
      ...this.state.arrayFile
    ]

    newData.splice(index, 1);
    this.setState({
      arrayFile: newData
    }, () => {
      this.props.onChange(newData);
    });
  }

  render() {
    return (
      <div>
        <h3 className="txt-12 txt-bold txt-upper mb10 mt0">{this.props.title}</h3>
        <div className="desc mb10">
          <p style={{ marginLeft: 0 }}>{this.props.note}</p>
        </div>
        <div className="result-upload mb20">
          {this.state.arrayFile.map((item, i) => {
            return (
              <div className="items-upload mb10" key={i}>
                <ShowIf condition={item.progress > 0}>
                  <div className="pt-progress-bar progress-upload pt-intent-primary">
                    <div className="pt-progress-meter"
                      style={{ width: `${item.progress}%` }} >
                    </div>
                  </div>
                </ShowIf>
                <ShowIf condition={item.progress <= 0}>
                  <div className="item-upload">
                    <ShowIf condition={!checkServerLive}>
                      <Link onClick={fileDownload.bind(this, item.urlFile, item.tenFile)} className="txt-blue txt-underline mr20 name-file-upload">{item.tenFile}</Link>
                    </ShowIf>
                    <ShowIf condition={checkServerLive}>
                      <Link onClick={()=>{downloadFile(item.urlFile, item.tenFile)}} className="txt-blue txt-underline mr20 name-file-upload">{item.tenFile}</Link>
                    </ShowIf>
                      <div className="wrap-upload-item mr15">Tải lại
                        <input type="file" className="btn-reupload" onChange={this.uploadFile.bind(this, i)} />
                      </div>
                    <Link className="itt-delete" onClick={this.handleRemove.bind(this, i)}>Xóa</Link>
                  </div>
                </ShowIf>
              </div>
              )
            })
          }
        </div>
        <div className="wrap-upload mb20">
          <span className="btn-upload">Tải lên
            <input type="file" name='giayUyQuyen' className="upload" onChange={this.uploadFile.bind(this, this.state.arrayFile.length)} />
          </span>
        </div>
      </div>
    )
  }
}

UploadNonTable.defaultProps = {
  typeArrayUpload: 'UY_QUYEN',
  arrayFileUpload: [],
  title: 'DANH SÁCH GIẤY ỦY QUYỀN',
  note: 'Định dạng tập tin đính kèm: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung lượng tối đa: 50mb',
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  }
}

export default UploadNonTable;



// WEBPACK FOOTER //
// ./src/components/upload/upload-nontable.jsx